import JSONAPISerializer from '@ember-data/serializer/json-api';

export default class Application extends JSONAPISerializer {
  keyForAttribute(key: string) {
    return key;
  }
}

// // DO NOT DELETE: this is how TypeScript knows how to look up your serializers.
// declare module 'ember-data/types/registries/serializer' {
//   export default interface SerializerRegistry {
//     application: Application;
//   }
// }
